// extracted by mini-css-extract-plugin
export default {"addBtn":"employes_addBtn__ha-qb"};